<template>
  <fragment v-if="campaign">
    <div class="channel-edit-group channel-edit-group-fields">
      <div class="field-w">
        <b-field :label="$t('CampaignEdit.Tags.Title')">
          <b-dropdown :value="campaignEditSelectedTagsIds" multiple scrollable aria-role="list" class="multiple"
                @active-change="onDropdownActiveChange" @change="onSelectedTagsIdsChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t("CampaignEdit.Tags.Title") }} ({{ campaignEditSelectedTagsIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="tagSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="tag in tagsFiltered" :key="tag.Id" :value="tag.Id" aria-role="listitem">
              <span class="text">{{ tag.Tag }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-field>
      </div>
    </div>
  </fragment>
</template>

<script lang="ts">
import Fragment from "vue-fragment";
import { Component, Vue, Watch } from "vue-property-decorator";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/he";
import { Action, Getter } from "vuex-class";
import { Campaign, CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { CampaignEditPageKind } from "@/models/campaigns/CampaignEditPageKind";
import { CampaignEditTagsData } from "@/models/campaigns/CampaignEditTagsData";
import { LeadTag } from "@/models/campaigns/LeadTag";
import CampaignService from "@/services/CampaignService";
import HelperService from "@/services/HelperService";
import CampaignsApiService from "@/services/api/CampaignsApiService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";

Vue.use(Fragment.Plugin);
const namespace = "campaignsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
  },
})
export default class TabTags extends Vue {

  //#region Vuex getters and actions

  @Getter("campaignEditSelectedTagsIds", { namespace }) campaignEditSelectedTagsIds!: number[];
  @Getter("campaignEditViewModel", { namespace }) campaignEditViewModel!: CampaignEditViewModel;
  @Action("setCampaignEditSelectedTagsIds", { namespace }) setCampaignEditSelectedTagsIds!: (campaignEditSelectedTagsIds: number[]) => Promise<void>;

  //#endregion Vuex getters and actions


  //#region Properties

  tagSearch = "";
  campaignEditTagsData?: CampaignEditTagsData = {
    TagIds: [],
    Tags: []
  };

  CampaignEditPageKind = CampaignEditPageKind;

  //#endregion Properties


  //#region Watchers

  @Watch("campaignEditViewModel", { immediate: true })
  onCampaignEditViewModelChange(newCampaignEditViewModel: CampaignEditViewModel, oldCampaignEditViewModel: CampaignEditViewModel): void {
    if (!newCampaignEditViewModel) {
      return;
    }
    const loader = this.$loading.show();
    CampaignsApiService.getCampaignEditTagsData(this.campaign).then((data: CampaignEditTagsData) => {
      this.campaignEditTagsData = data;
      this.setCampaignEditSelectedTagsIds(data.TagIds);
    }).finally(() => {
      loader.hide();
    });
  }

  //#endregion Watchers


  //#region Getters

  get campaign(): Campaign {
    return this.campaignEditViewModel?.Campaign;
  }

  get pageKind(): CampaignEditPageKind {
    return CampaignService.getCampaignEditPageKind(this.$route.path);
  }

  get tagsFiltered(): LeadTag[] {
    if (this.campaignEditTagsData) {
      return this.campaignEditTagsData.Tags.filter((i: LeadTag) => i.Tag.toLowerCase().indexOf(this.tagSearch.toLowerCase()) >= 0);
    }
    return [];
  }

  //#endregion Getters


  //#region Handlers

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onSelectedTagsIdsChange(selectedTagsIds: number[]) {
    this.setCampaignEditSelectedTagsIds(selectedTagsIds);
  }

  //#endregion Handlers
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.channel-edit-group {
  margin-bottom: 25px;

  &.channel-edit-group-field {
    max-width: 894px;

    .channel-edit-field {
      margin-bottom: 1rem;
    }

    .label {
      font-size: 17px;
      margin: 0;
      display: inline;
    }
  }

  &.channel-edit-group-fields {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -12px;

    .field-w {
      padding: 0 12px 25px;
      flex-grow: 1;
      width: 50%;

      .dropdown {
        width: 100%;

        .dropdown-item-with-icon {
          display: flex;

          .icon-w {
            display: flex;
            margin-inline-end: 0.5rem;
            min-width: 22px;

            img {
              max-height: 22px;
              min-width: 22px;
              width: 22px;
            }
          }
        }

        .dropdown-trigger {

          .button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
